export const W_ARRAYS = {
  W_dailyInterestAccounts: 'W_dailyInterestAccounts',
  W_highYieldAccounts: 'W_highYieldAccounts',
  W_guaranteedInterestAccounts: 'W_guaranteedInterestAccounts',
  W_benevaInvestmentAccounts: 'W_benevaInvestmentAccounts',
  W_benevaGuaranteedInvestmentFunds: 'W_benevaGuaranteedInvestmentFunds',
} as const;

export const W_ARRAYS_ADD_BUTTONS = {
  W_dailyInterestAccounts: 'W_addDailyInterestAccount',
  W_guaranteedInterestAccounts: 'W_addGuaranteedInterestAccount',
  W_benevaInvestmentAccounts: 'W_addBenevaInvestmentAccount',
  W_highYieldAccounts: 'W_addHighYieldAccount',
  W_benevaGuaranteedInvestmentFunds: 'W_addBenevaGuaranteedInvestmentFund',
} as const;

export const ALL_W_ARRAYS = Object.values(W_ARRAYS);
export const ALL_W_ARRAYS_ADD_BUTTONS = Object.values(W_ARRAYS_ADD_BUTTONS);

export type W_Array = (typeof ALL_W_ARRAYS)[number];
